import React, { useState } from 'react';
import PnLTreeList from '../components/pnl/PnLTreeList';
import PnLCorrelations from '../components/pnl/PnLCorrelations';
import { PnLCurrentYearChart, PnLHistoryChart } from '../components/pnl/PnLCharts';
import PnLDashboard from '../components/pnl/PnLDashboard';
import './PnL.css';
import SeasonalityDashboard from "./SeasonalityDashboard";
import PageShell from '../components/layout/PageShell';

type ViewType = 'dashboard' | 'seasonality' | 'metrics' | 'traders_pnl' | 'bu_pnl' | 'correlations' | 'charts' | 'history' | null;

const PandL: React.FC = () => {
  const [activeView, setActiveView] = useState<ViewType>('dashboard');


return (
     <PageShell>
      <nav className="nav-bar">
        <div
          className={`nav-item ${activeView === 'dashboard' ? 'active' : ''}`}
          onClick={() => setActiveView('dashboard')}
        >
          Dashboard
        </div>
        <div
          className={`nav-item ${activeView === 'seasonality' ? 'active' : ''}`}
          onClick={() => setActiveView('seasonality')}
        >
          Seasonality
        </div>
        <div
          className={`nav-item ${activeView === 'bu_pnl' ? 'active' : ''}`}
          onClick={() => setActiveView('bu_pnl')}
        >
          BU P&L
        </div>

        <div
          className={`nav-item ${activeView === 'traders_pnl' ? 'active' : ''}`}
          onClick={() => setActiveView('traders_pnl')}
        >
          Traders P&L
        </div>

        <div
          className={`nav-item ${activeView === 'metrics' ? 'active' : ''}`}
          onClick={() => setActiveView('metrics')}
        >
          P&L
        </div>

        <div
          className={`nav-item ${activeView === 'correlations' ? 'active' : ''}`}
          onClick={() => setActiveView('correlations')}
        >
          Correlation
        </div>
        <div
          className={`nav-item ${activeView === 'charts' ? 'active' : ''}`}
          onClick={() => setActiveView('charts')}
        >
          Charts
        </div>
        <div
          className={`nav-item ${activeView === 'history' ? 'active' : ''}`}
          onClick={() => setActiveView('history')}
        >
          History
        </div>

      </nav>
      <div className="view-stack">
      <div className={`view-pane ${activeView==='dashboard' ?'is-active':''}`}>
        <div className="content-container2">
          <button className="close-button" onClick={()=> setActiveView(null)}>×</button>
          <PnLDashboard />
        </div>
      </div>
      <div className={`view-pane ${activeView==='seasonality' ?'is-active':''}`}>
        <div className="content-container2">
          <button className="close-button" onClick={()=> setActiveView(null)}>×</button>
          <SeasonalityDashboard />
        </div>
      </div>
      <div className={`view-pane ${activeView==='metrics' ?'is-active':''}`}>
        <div className="content-container2">
          <button className="close-button" onClick={()=> setActiveView(null)}>×</button>
          <div className="content-note">
            <strong>Note:</strong>
            <br /> Italian PPA P&amp;L is reported t-2 <br /> CF Flex P&amp;L represents CF share of the P&amp;L and is calculated after taking an estimate of operating costs and tax.
          </div>
          <PnLTreeList page={'all'}/>
        </div>
      </div>

      <div className={`view-pane ${activeView==='traders_pnl' ?'is-active':''}`}>
        <div className="content-container2">
          <button className="close-button" onClick={()=> setActiveView(null)}>×</button>

          <PnLTreeList page={'traders'}/>
        </div>
      </div>

      <div className={`view-pane ${activeView==='bu_pnl' ?'is-active':''}`}>
        <div className="content-container2">
          <button className="close-button" onClick={()=> setActiveView(null)}>×</button>

          <PnLTreeList page={'bu_pnl'}/>
        </div>
      </div>

      <div className={`view-pane ${activeView==='correlations' ?'is-active':''}`}>
        <div className="content-container2">
          <button className="close-button" onClick={()=> setActiveView(null)}>×</button>
          <PnLCorrelations />
        </div>
      </div>
      <div className={`view-pane ${activeView==='charts' ?'is-active':''}`}>
        <div className="content-container2">
          <button className="close-button" onClick={()=> setActiveView(null)}>×</button>
          <PnLCurrentYearChart page={activeView} />
        </div>
      </div>
      <div className={`view-pane ${activeView==='history' ?'is-active':''}`}>
        <div className="content-container2">
          <button className="close-button" onClick={()=> setActiveView(null)}>×</button>
          <PnLHistoryChart page={activeView} />
        </div>
      </div>
    </div>
     </PageShell> );
};

export default PandL;
